/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-27 20:04:45
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-27 20:21:01
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/TextArea/BlurValidateTextArea.tsx
 */
import React from 'react';

import TextArea from './TextArea';

const BlurValidateTextArea = (props) => {
  const { onFocus, validate, onChange, value, ...rest } = props;

  const handleOnChange = () => {
    if (validate) validate(value);
  };
  return (
    <TextArea
      onFocus={onFocus}
      onChange={onChange}
      value={value}
      onBlur={handleOnChange}
      {...rest}
    />
  );
};
export default BlurValidateTextArea;
